export default __webpack_public_path__ + "static/media/b4.6997bba3.jpg";